import { range } from 'lodash'

import { ExecuteCommandPayload, MutationType, ObjectDataRecord } from '@types'

type PagedData = {
  data: ObjectDataRecord[]
  totalCount: number
}

type GetAllPagesDataParams = {
  firstPageData: PagedData
  executeCommand: MutationType<ExecuteCommandPayload, unknown>
  commandParams: ExecuteCommandPayload
}

export const getAllPagesData = ({
  firstPageData,
  executeCommand,
  commandParams,
}: GetAllPagesDataParams): Promise<ObjectDataRecord[]> => {
  const { data, totalCount } = firstPageData

  if (totalCount <= 1) {
    return Promise.resolve(data)
  }

  return (async () => {
    const requests = range(1, totalCount).map(page =>
      executeCommand({
        ...commandParams,
        params: { ...commandParams.params, page },
      }).unwrap()
    )

    const results = await Promise.all(requests)

    return [...data, ...(results as PagedData[]).flatMap(r => r.data)]
  })()
}
